import { render } from "./AccountAndData.vue?vue&type=template&id=0225ef44&scoped=true"
import script from "./AccountAndData.vue?vue&type=script&lang=js"
export * from "./AccountAndData.vue?vue&type=script&lang=js"

import "./AccountAndData.vue?vue&type=style&index=0&id=0225ef44&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225ef44"]])

export default __exports__